import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import ErrorScreen from "../components/ErrorScreen";
import { apiFetch } from "../utils/api";
import { formatTime } from "../utils/time";
import ProfileComplete from "./ProfileComplete";
import { USER_BASE_URL, VERSION } from "../utils/config";
import "../styles/Dashboard.css";
import "../styles/Loading.css";

export default function Dashboard() {
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await apiFetch(
          `${USER_BASE_URL}/${VERSION}/course/web/list`,
          "GET",
          null,
          { "Content-Type": "application/json" }
        );
        console.log(data);
        if (data) {
          setCourses(data.courses);
        } else {
          setError("server_error");
        }
        setLoading(false);
      } catch (err) {
        console.log(err);
        if (err.type === "version_reloading") {
          return;
        }
        if (err.code && err.code === 406) {
          setError(err.type || "account_blocked");
        } else if (err.code && err.code === 400) {
          setError("400");
          setErrorMsg(err.message);
        } else {
          setError("server_error");
        }
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <div className="spinner"></div>
          <p>Loading</p>
        </div>
      </div>
    );
  }

  // ✅ Special handling for profile-completion error
  if (errorMsg === "Please complete your profile first.") {
    return <ProfileComplete />;
  }

  // ✅ Show error screen if we have an error
  if (error) {
    return (
      <ErrorScreen
        type={error}
        {...(error === "400" && {
          onMessage: errorMsg,
          onAction: () => {
            window.open(
              "https://share.g9eduinternational.com/course",
              "_blank"
            );
          },
        })}
      />
    );
  }

  return (
    <div className="dashboard-wrapper">
      <Navbar />
      <div className="greeting">
        <h1>
          Hi, {localStorage.getItem("username")?.trim() || "User"}{" "}
          <span className="wave">👋</span>
        </h1>
        <p>Ready to learn something new today?</p>
      </div>

      <h2 className="section-title">Popular Courses</h2>

      <div className="courses-list">
        {courses.length === 0 ? (
          <p className="no-courses">No courses available, check back later!</p>
        ) : (
          courses.map((course) => (
            <div
              key={course._id}
              className="course-card"
              onClick={() => {
                setTimeout(() => {
                  navigate(`/courses/${course._id}`);
                }, 200);
              }}
            >
              <div className="course-image">
                <img src={course.banner_image.url} alt={course.title} />
              </div>
              <div className="course-info">
                <span className="course-tag">
                  {course.minimum_recommendation}
                </span>
                <h3 className="course-title">{course.title}</h3>

                <div className="course-meta">
                  <div className="meta-col">
                    <span>
                      <img src="/assets/images/video.png" alt="Video" />{" "}
                      {course.lesson_count} Lessons
                    </span>
                    <span>
                      <img src="/assets/images/time.png" alt="Time" />{" "}
                      {formatTime(course.video_duration + course.test_duration)}
                    </span>
                  </div>
                  <div className="meta-col">
                    <span>
                      <img src="/assets/images/pdf.png" alt="Notes" /> {course.pdf_count}{" "}
                      Notes
                    </span>
                    <span>
                      <img src="/assets/images/certs.png" alt="Certificates" /> Certificate
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
